<div class="row mt-2 button-row">
  <button class="btn addBtn" (click)="openAddLogModal()">Log HbA1c</button>
</div>

<div class="row mt-4">
  <div class="col-md-12">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="HbA1cValue">
        <th mat-header-cell *matHeaderCellDef> HbA1c Value (%) </th>
        <td mat-cell *matCellDef="let element">{{ element.hbA1cValue ?? '---' }}</td>
      </ng-container>
      <ng-container matColumnDef="EventDate">
        <th mat-header-cell *matHeaderCellDef> Event Date </th>
        <td mat-cell *matCellDef="let element">{{ formatEventDate(element) }}</td>
      </ng-container>
      <ng-container matColumnDef="Source">
        <th mat-header-cell *matHeaderCellDef> Source </th>
        <td mat-cell *matCellDef="let element">{{ element.source || '---' }}</td>
      </ng-container>
      <ng-container matColumnDef="LoggedBy">
        <th mat-header-cell *matHeaderCellDef> Logged By </th>
        <td mat-cell *matCellDef="let element">{{ element.loggedBy || '---' }}</td>
      </ng-container>
      <ng-container matColumnDef="ReportedDate">
        <th mat-header-cell *matHeaderCellDef> Reported Date </th>
        <td mat-cell *matCellDef="let element">{{ element.reportedDate ? (element.reportedDate | date: 'd MMMM y, HH:mm') : '---' }}</td>
      </ng-container>
      <ng-container matColumnDef="Action">
        <th mat-header-cell *matHeaderCellDef> Action </th>
        <td mat-cell *matCellDef="let element">
          <img src="assets/img/edit 1.png" alt="Edit HbA1c log" title="Edit" class="editIcon" (click)="openEditLogModal(element)" />
          <img src="assets/img/mealPlanDelete.png" alt="Delete HbA1c log" title="Delete" class="editIcon deleteIcon"
            (click)="openDeleteLogModal(element)" />
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell emptyText" [attr.colspan]="displayedColumns.length">{{ isLoading ? 'Loading data...' : 'No HbA1c logs found.' }}</td>
      </tr>
    </table>
    <div style="text-align:center;display:flex;">
      <mat-paginator
                     (page)="pageChangeEvent($event)"
                     [length]="totalRecords"
                     [pageSize]="pageSize"
                     [pageIndex]="pageIndex"
                     showFirstLastButtons>
      </mat-paginator>
    </div>
  </div>
</div>

<!-- Add / Update HbA1c Log Modal -->
<div class="modal fade" id="addHba1cLogModal" tabindex="-1" aria-labelledby="addHba1cLogModalLabel" data-bs-backdrop="static"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content radius">
      <div class="modal-header">
        <span class="title1" id="addHba1cLogModalLabel">{{ isEditMode ? 'Update HbA1c Log' : 'Add HbA1c Log' }}</span>
        <button type="button" class="close" aria-label="Close" (click)="closeAddLogModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <!-- Row 1: HbA1c value + event date format -->
        <div class="row mb-3">
          <div class="col-md-6">
            <span class="editSubText">HbA1c Value (%):</span>
            <input type="number" min="0" step="0.1" class="form-control editField" placeholder="HbA1c Value"
              [(ngModel)]="hbA1cValue" (keydown)="onValueKeyDown($event)" />
          </div>
          <div class="col-md-6">
            <span class="editSubText">Log Event Date As:</span>
            <select class="form-control editField" [(ngModel)]="eventDateFormat" (change)="onEventDateFormatChange()">
              <option value="monthYear">Month and Year</option>
              <option value="timestamp">Timestamp</option>
            </select>
          </div>
        </div>

        <!-- Row 2: Month + Year -->
        <div class="row mb-3" *ngIf="eventDateFormat === 'monthYear'">
          <div class="col-md-6">
            <span class="editSubText">Event Month:</span>
            <select class="form-control editField" [(ngModel)]="eventMonth">
              <option [ngValue]="null" disabled>Select Month</option>
              <option *ngFor="let month of months" [ngValue]="month.value" [disabled]="isFutureMonth(month.value)">{{ month.name }}</option>
            </select>
          </div>
          <div class="col-md-6">
            <span class="editSubText">Event Year:</span>
            <select class="form-control editField" [(ngModel)]="eventYear" (ngModelChange)="onEventYearChange()">
              <option [ngValue]="null" disabled>Select Year</option>
              <option *ngFor="let year of years" [ngValue]="year">{{ year }}</option>
            </select>
          </div>
        </div>

        <!-- Row 2: Date + Time -->
        <div class="row mb-3" *ngIf="eventDateFormat === 'timestamp'">
          <div class="col-md-6">
            <span class="editSubText">Event Date:</span>
            <input type="date" class="form-control editField" [max]="maxDate" [(ngModel)]="eventDate" />
          </div>
          <div class="col-md-6">
            <span class="editSubText">Event Time:</span>
            <input type="time" class="form-control editField" [(ngModel)]="eventTime" />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn applyBtn" (click)="submitLog()" [disabled]="isSaving || !hasChanges">
          <ng-container *ngIf="isEditMode">{{ isSaving ? 'Updating...' : 'Update Log' }}</ng-container>
          <ng-container *ngIf="!isEditMode">{{ isSaving ? 'Adding...' : 'Add Log' }}</ng-container>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Delete HbA1c Log Confirmation Modal -->
<div class="modal fade" id="deleteHba1cLogModal" tabindex="-1" aria-labelledby="deleteHba1cLogModalLabel" data-bs-backdrop="static"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content radius">
      <div class="modal-header">
        <span class="title1" id="deleteHba1cLogModalLabel">Please Confirm!</span>
        <button type="button" class="close" aria-label="Close" (click)="closeDeleteLogModal()" [disabled]="isDeleting">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="modalText">Are you sure you want to delete this HbA1c log?</div>
        <div class="deleteLogDetails" *ngIf="logToDelete">
          <div><span class="editSubText">HbA1c Value (%):</span> {{ logToDelete.hbA1cValue ?? '---' }}</div>
          <div><span class="editSubText">Event Date:</span> {{ formatEventDate(logToDelete) }}</div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn cancelBtn" (click)="closeDeleteLogModal()" [disabled]="isDeleting">Cancel</button>
        <button type="button" class="btn applyBtn" (click)="confirmDeleteLog()" [disabled]="isDeleting">
          {{ isDeleting ? 'Deleting...' : 'OK' }}
        </button>
      </div>
    </div>
  </div>
</div>
